export const DEACTIVATE_FLEET_PARADE = Symbol('DEACTIVATE_FLEET_PARADE');
export const ACTIVATE_FLEET_PARADE = Symbol('ACTIVATE_FLEET_PARADE');

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function deactivateFleetParade () {

	return {
		type: DEACTIVATE_FLEET_PARADE
	};
}

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function activateFleetParade () {

	return {
		type: ACTIVATE_FLEET_PARADE
	};
}
